import { mapState } from "ui.vue3.vuex";
import Modal from "../components/modal";

import ClaimStatement from "../views/Statements/ClaimStatement/index"
import FreeFormStatement from "../views/Statements/FreeFormStatement/index"
import RefundStatement from "../views/Statements/RefundStatement/index"
import TechnicalFailureStatement from "../views/Statements/TechnicalFailureStatement/index"

const Application = {
    computed: {
        ...mapState({
            show: (state) => state.modal.view,
        }),
    },

    components: {
        ClaimStatement,
        FreeFormStatement,
        RefundStatement,
        TechnicalFailureStatement
    },

    data() {
        return {
            current_component: null
        }
    },

    created() {
        switch (this.$bitrix.Application.instance.app_type) {
            case "refund-of-funds": {
                // this.$router.push({ name: "refund-1" });
                this.current_component = RefundStatement
                break;
            }

            case "free-form": {
                // this.$router.push({ name: "freeform-1" });
                this.current_component = FreeFormStatement
                break;
            }

            case "technical-failure": {
                // this.$router.push({ name: "techfailure-1" });
                this.current_component = TechnicalFailureStatement
                break;
            }

            case "claim": {
                // this.$router.push({ name: "claim-1" });
                this.current_component = ClaimStatement
                break;
            }
        }
    },

    methods: {
        close() {
            this.$store.dispatch("modal/close");
        },
    },

    components: {
        Modal,
    },

    template: /*html*/ `
      <component :is="current_component"></component>
      <transition name="fade">
        <Modal v-show="show" @close="close"> </Modal>
      </transition>
    `,
};

export default Application;
